import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  postLinkApplicationService,
  postSearchLinkApplicationService,
} from "../Services/LinkApplicationService";
import {
  API_INITIAL_STATE,
  BUILDER_TYPE_FULFILLED,
  BUILDER_TYPE_PENDING,
  SLICE_LINK_APPLICATION,
  THUNK_POST_LINK_APPLICATION,
  THUNK_POST_SEARCH_LINK_APPLICATION,
} from "../Constants/SliceAndThunkConstants";
import { apiSliceBuilderService } from "../Services/CommonServices";

export const postLinkApplication = createAsyncThunk(
  `${SLICE_LINK_APPLICATION}/${THUNK_POST_LINK_APPLICATION}`,
  async (payload) => {
    const response = await postLinkApplicationService(payload);
    return response;
  }
);

export const postSearchLinkApplication = createAsyncThunk(
  `${SLICE_LINK_APPLICATION}/${THUNK_POST_SEARCH_LINK_APPLICATION}`,
  async (payload) => {
    const response = await postSearchLinkApplicationService(payload);
    return response;
  }
);

const initialState = {
  hapIdData: {
    hapId: "",
    dateOfBirth: "",
  },
  searchForHapIdData: {
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    sexCode: "",
    zipCode: "",
  },
  responseData: {
    hapId: "",
    firstName: "",
    lastName: "",
  },

  postLinkApplicationResponse: API_INITIAL_STATE,
  postSearchLinkApplicationResponse: API_INITIAL_STATE,
};

export const linkApplicationSlice = createSlice({
  name: "linkApplication",
  initialState,
  reducers: {
    saveLinkApplication: (state, action) => {
      state.hapIdData.hapId = action.payload.hapId;
      state.hapIdData.dateOfBirth = action.payload.dateOfBirth;
      state.searchForHapIdData.dateOfBirth = "";
      state.searchForHapIdData.firstName = "";
      state.searchForHapIdData.lastName = "";
      state.searchForHapIdData.sexCode = "";
      state.searchForHapIdData.zipCode = "";
    },
    saveSearchHapId: (state, action) => {
      state.hapIdData.hapId = "";
      state.hapIdData.dateOfBirth = "";
      state.searchForHapIdData.firstName = action.payload.firstName;
      state.searchForHapIdData.lastName = action.payload.lastName;
      state.searchForHapIdData.dateOfBirth = action.payload.dateOfBirth;
      state.searchForHapIdData.sexCode = action.payload.sexCode;
      state.searchForHapIdData.zipCode = action.payload.zipCode;
    },
    clearSearchHapId: (state) => {
      state.searchForHapIdData.dateOfBirth = "";
      state.searchForHapIdData.firstName = "";
      state.searchForHapIdData.lastName = "";
      state.searchForHapIdData.sexCode = "";
      state.searchForHapIdData.zipCode = "";
    },
    clearLinkApplicationResponse: (state, action) => {
      const responseName = `${action.payload}Response`;
      if (!initialState[responseName]) {
        return;
      }
      state[responseName] = initialState[responseName];
    },
    clearLinkApplicationSlice: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(postLinkApplication.pending, (state) => {
      state.postLinkApplicationResponse =
        apiSliceBuilderService(BUILDER_TYPE_PENDING);
    });
    builder.addCase(postLinkApplication.fulfilled, (state, action) => {
      state.postLinkApplicationResponse = apiSliceBuilderService(
        BUILDER_TYPE_FULFILLED,
        action
      );

      state.responseData.firstName = action?.payload?.data?.data?.firstName;
      state.responseData.lastName = action?.payload?.data?.data?.lastName;
      state.responseData.hapId = action?.payload?.data?.data?.hapId;
    });
    builder.addCase(postSearchLinkApplication.pending, (state) => {
      state.postSearchLinkApplicationResponse =
        apiSliceBuilderService(BUILDER_TYPE_PENDING);
    });
    builder.addCase(postSearchLinkApplication.fulfilled, (state, action) => {
      state.postSearchLinkApplicationResponse = apiSliceBuilderService(
        BUILDER_TYPE_FULFILLED,
        action
      );

      state.responseData.firstName = action?.payload?.data?.data?.firstName;
      state.responseData.lastName = action?.payload?.data?.data?.lastName;
      state.responseData.hapId = action?.payload?.data?.data?.hapId;
    });
  },
});

export const {
  saveLinkApplication,
  saveSearchHapId,
  clearLinkApplicationResponse,
  clearLinkApplicationSlice,
  clearSearchHapId
} = linkApplicationSlice.actions;

export default linkApplicationSlice.reducer;
